function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.02 48.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M48,22.55A24,24,0,1,0,24,48.06H38a10,10,0,0,0,10-10ZM44,38.06a6,6,0,0,1-6,6H24A20.06,20.06,0,0,1,9.09,37.37a19.83,19.83,0,0,1-5-15.63A20.11,20.11,0,0,1,21.45,4.21a22.54,22.54,0,0,1,2.6-.16,19.87,19.87,0,0,1,12.76,4.6A20.12,20.12,0,0,1,44,22.74Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,18.05h8a2,2,0,0,0,0-4H16a2,2,0,0,0,0,4Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,22.06H16a2,2,0,0,0,0,4H32a2,2,0,0,0,0-4Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,30.06H16a2,2,0,0,0,0,4H32a2,2,0,0,0,0-4Z",
    style: {
      fill: "currentColor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.be3695ad.svg";
export { ForwardRef as ReactComponent };